import React from 'react';
import { RefreshCw, Copy, CheckCheck, Loader2, Save } from 'lucide-react';
import { Ticket } from '../../lib/types';
import { Action, Badge } from '../Common';

export type DraftActionProps = {ticket: Ticket; draft: string; saving: boolean;
  onPatch: (changes: Partial<Ticket>) => void; onSave: () => void;
  onApprove: () => void; onRegenerate: () => void};

export const DraftActions = ({ticket, draft, saving, onPatch, onSave, onApprove, onRegenerate}: DraftActionProps) => {
  if (ticket.status === 'resolved') return <div className="draft-actions">
    <Action data-testid="reopen-ticket-button" variant="outline" onClick={() => onPatch({status: 'new'})} disabled={saving}><RefreshCw/>Reopen ticket</Action>
    <Badge value="resolved" testId="resolved-confirmation"/>
  </div>;
  const dirty = draft !== ticket.draft;
  return <div className="draft-actions">
    <Action variant="outline" size="icon" data-testid="action-regenerate-draft-button" title="Regenerate reply" disabled={saving} onClick={onRegenerate}><RefreshCw size={15}/></Action>
    {dirty && <Action variant="outline" data-testid="save-draft-button" title="Save changes" disabled={saving} onClick={onSave}><Save size={15}/><span>Save</span></Action>}
    <Action className="approve-button" data-testid="action-approve-copy-button" disabled={saving || !draft.trim()} onClick={onApprove}>{saving ? <Loader2 className="spin" size={15}/> : <Copy size={15}/>}Approve & copy</Action>
    {ticket.approved_at && !dirty && <Action data-testid="action-mark-resolved-button" variant="outline" disabled={saving} onClick={() => onPatch({status: 'resolved'})}><CheckCheck size={15}/>Resolve</Action>}
  </div>;
};